export const FETCH_GATE = 'GATE/FETCH_REQUEST';
export const FETCH_GATE_SUCCESS = 'GATE/FETCH_SUCCESS';

export const FETCH_GATES = 'GATES/FETCH_REQUEST';
export const FETCH_GATES_SUCCESS = 'GATES/FETCH_SUCCESS';

export const FETCH_AVAILABLE_GATES = 'GATES/FETCH_AVAILABLE_REQUEST';
export const FETCH_AVAILABLE_GATES_SUCCESS = 'GATES/FETCH_AVAILABLE_SUCCESS';

export const FETCH_GATES_FILTER = 'GATES/FETCH_FILTER_REQUEST';
export const FETCH_GATES_FILTER_SUCCESS = 'GATES/FETCH_FILTER_SUCCESS';
export const FETCH_GATES_FILTER_FAILURE = 'GATES/FETCH_FILTER_FAILURE';

export const CREATE_GATE = 'GATE/CREATE_REQUEST';
export const CREATE_GATE_SUCCESS = 'GATE/CREATE_SUCCESS';

export const UPDATE_GATE = 'GATE/UPDATE_REQUEST';
export const UPDATE_GATE_SUCCESS = 'GATE/UPDATE_SUCCESS';

export const DELETE_GATE = 'GATE/DELETE_REQUEST';
export const DELETE_GATE_SUCCESS = 'GATE/DELETE_SUCCESS';

export const GATE_READY = 'GATE/READY';

export const SET_GATES_DASHBOARD_FILTER = 'GATES/DASHBOARD/FILTER/SET';
export const CLEAR_GATES_DASHBOARD_FILTER = 'GATES/DASHBOARD/FILTER/CLEAR';

export const RESTRICTED_ACCESS_RELAY_CHECK = 'GATE/RESTRICTED_ACCESS/RELAY_CHECK_REQUEST';

export const DOWNLOAD_PUBLIC_QR_CODE_REQUEST = 'GATE/DOWNLOAD_PUBLIC_QR_CODE_REQUEST';
export const DOWNLOAD_PUBLIC_QR_CODE_SUCCESS = 'GATE/DOWNLOAD_PUBLIC_QR_CODE_SUCCESS';
export const DOWNLOAD_PUBLIC_QR_CODE_FAILURE = 'GATE/DOWNLOAD_PUBLIC_QR_CODE_FAILURE';

export const FETCH_GATE_OPENINGS = 'GATE/FETCH_OPENINGS_REQUEST';
export const FETCH_GATE_OPENINGS_SUCCESS = 'GATE/FETCH_OPENINGS_SUCCESS';
